<template>
  <v-container>
    <v-row justify="center" no-gutters>
      <v-col cols="12">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <div class="d-flex" style="position: absolute; right: 12px;">
              <v-icon v-on="on">
                info
              </v-icon>
            </div>
          </template>
          <div>
            Tip: You can drag and drop columns to change their order in the list.
          </div>
        </v-tooltip>
        <v-list dense subheader>
          <v-subheader>Available Columns</v-subheader>
          <draggable v-model="columns" group="headers" @start="drag=true" @end="updateOrder()">
            <transition-group>
              <v-list-item v-for="header in columns" :key="header.value" dense row style="width: 100%; cursor: pointer" justify-between>
                <v-list-item-content dense>
                  {{ header.text }}
                </v-list-item-content>
                <v-list-item-action class="ma-0">
                  <v-btn icon class="mx-0" @click.stop="toggleVisibility(header.value)">
                    <v-icon color="grey darken-2">
                      {{ isVisible(header.value) ? 'visibility' : 'visibility_off' }}
                    </v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </transition-group>
          </draggable>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import draggable from 'vuedraggable'

export default {
  components: {
    draggable
  },
  props: {
    visibleColumns: {
      type: Array,
      required: true
    },
    availableHeaders: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      columns: []
    }
  },
  mounted() {
    this.sortColumnsForVisuals()
  },
  methods: {
    sortColumnsForVisuals() {
      let columns = []
      const available = [...this.availableHeaders]

      this.visibleColumns.forEach((visible) => {
        const itemIndex = available.findIndex(i => i.value === visible)
        if (itemIndex >= 0) {
          const item = available[itemIndex]
          columns.push(item)
          available.splice(itemIndex, 1)
        }
      })
      
      columns = columns.concat(available)
      this.columns = columns
    },
    toggleVisibility(key) {
      const columns = this.isVisible(key) ? this.visibleColumns.filter(x => x !== key) : [...this.visibleColumns, key]
      const newVisible = this.orderColumns(columns)
      this.$emit('newvisible', newVisible)
    },
    orderColumns(columns) {
      return this.columns.reduce((newList, column) => {
        if (columns.includes(column.value)) { newList.push(column.value) }
        return newList
      }, [])
    },
    isVisible(key) {
      return this.visibleColumns.includes(key)
    },
    updateOrder() {
      this.$emit('newvisible', this.columns.map(column => column.value).filter(a => this.visibleColumns.includes(a)))
    }
  }
}
</script>
